import BulkEditModalContent from './BulkEditModalContent';
import { BulkEditModalProps } from './constants';
import { BulkEditProvider } from './context';

const BulkEditModal = ({ data, onClose, ...props }: BulkEditModalProps) => {
  return (
    <BulkEditProvider
      adGroups={data.adGroups || []}
      campaign={data.campaign}
      advertiser={data.advertiser}
      onClose={onClose}
    >
      <BulkEditModalContent data={data} {...props} />
    </BulkEditProvider>
  );
};

export default BulkEditModal;
